'use strict';

/**
 * Scroll to element in container.
 * Note: There is "no scroll" scenario based on inCenterMaxDistance arg.
 * @param {Element} element - element we scroll to
 * @param {Element} container - container with scroll
 * @param {integer} inCenterMaxDistance - defines "no scroll" distance (element is already close enough to container center)
 */
module.exports = function (element, container, inCenterMaxDistance = 150) {
    if (!element || !container) {
        return;
    }
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const topSpace = elementRect.top - containerRect.top;
    const bottomSpace = containerRect.bottom - elementRect.bottom;

    const distanceFromContainerCenter = (topSpace - bottomSpace) / 2;
    if (Math.abs(distanceFromContainerCenter) <= inCenterMaxDistance) {
        return;
    }

    const top = container.scrollTop + distanceFromContainerCenter;

    container.scrollTo({
        top: top,
        behavior: 'smooth'
    });
};
